/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host([disabled]) {
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--calcite-opacity-disabled);
}

:host([disabled]) *,
:host([disabled]) ::slotted(*) {
  pointer-events: none;
}

:host {
  display: block;
}

:host([scale=s]) .controls-wrapper {
  block-size: 1.5rem;
}

:host([scale=m]) .controls-wrapper {
  block-size: 2rem;
}

:host([scale=l]) .controls-wrapper {
  block-size: 2.75rem;
}

:host(:not([editing-enabled]):not([disabled])) .wrapper:hover {
  background-color: var(--calcite-color-foreground-2);
}

.wrapper {
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  background-color: var(--calcite-color-foreground-1);
  transition: background-color, block-size, border-color, box-shadow, color, inset-block-end, inset-block-start, inset-inline-end, inset-inline-start inset-size, opacity, outline-color, transform var(--calcite-animation-timing) ease-in-out 0s, outline 0s, outline-offset 0s;
}
.wrapper .input-wrapper {
  flex: 1 1 0%;
}

.controls-wrapper {
  display: flex;
}

:host([disabled]) .cancel-editing-button-wrapper {
  border-color: var(--calcite-color-border-2);
}
:host([disabled]) ::slotted([calcite-hydrated][disabled]),
:host([disabled]) [calcite-hydrated][disabled] {
  /* prevent opacity stacking */
  opacity: 1;
}

.interaction-container {
  display: contents;
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}